import { Component } from '@angular/core'

@Component({
  template: '<ftr-logout></ftr-logout>',
})
export class LogoutPage {}
